import React, { useState, useEffect } from "react";
import { isEmpty } from "lodash";

import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
} from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

// actions
import { editProfile } from "../../store/actions";
import { createSelector } from "reselect";
import { getSessionData } from "../../helpers/sessionDetailsParser";
import { documentTitle } from "../../helpers/documentTitle";
import { useNavigate } from "react-router-dom";

const UserProfile = () => {
  const dispatch = useDispatch();

  const [email, setemail] = useState("admin@gmail.com");
  const [idx, setidx] = useState("1");
  const [userType, setUserType] = useState("1");

  const [userName, setUserName] = useState(getSessionData("user_name"));

  const selectLayoutState = (state) => state.Profile;
  const userprofileData = createSelector(selectLayoutState, (userpro) => ({
    user: userpro.user,
    success: userpro.success,
    error: userpro.error,
  }));

  // Inside your component
  const { user, success, error } = useSelector(userprofileData);

  useEffect(() => {
    setUserName(getSessionData("user_name"));
    setemail(getSessionData("phone_number"));
    setidx(getSessionData("user_id"));
    setUserType(getSessionData("user_type"));
  },[]);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      first_name: userName || "Admin",
      idx: idx || "",
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required("Please Enter Your UserName"),
    }),
    onSubmit: (values) => {
      dispatch(editProfile(values));
    },
  });

  documentTitle("Profile");

  const navigate = useNavigate();

  const handlePersonalDetailsNavigate = () => {
    navigate("/personalDetails-list");
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col lg="12">
              {error && error ? <Alert color="danger">{error}</Alert> : null}
              {success ? (
                <Alert color="success">Username Updated To {userName}</Alert>
              ) : null}

              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="mx-3">
                      <img
                        // src={avatar}
                        src="https://img.freepik.com/premium-vector/avatar-profile-icon-flat-style-male-user-profile-vector-illustration-isolated-background-man-profile-sign-business-concept_157943-38764.jpg"
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <h5>{userName || "Admin"}</h5>
                        <p className="mb-1">Mobile Number : {email}</p>
                        <p className="mb-0">User ID : #{idx}</p>
                        <p className="mb-0">User Type : {userType}</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <h4 className="card-title mb-4">User Name</h4>

          <Card>
            <CardBody>
              <Form
                className="form-horizontal"
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <div className="form-group">
                  <Label className="form-label">User Name</Label>
                  <Input
                    name="first_name"
                    // value={name}
                    className="form-control"
                    placeholder="Enter User Name"
                    type="text"
                    disabled
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.first_name || ""}
                    invalid={
                      validation.touched.first_name &&
                      validation.errors.first_name
                        ? true
                        : false
                    }
                  />
                  {validation.touched.first_name &&
                  validation.errors.first_name ? (
                    <FormFeedback type="invalid">
                      {validation.errors.first_name}
                    </FormFeedback>
                  ) : null}
                  <Input name="idx" value={idx} type="hidden" />
                </div>
                <div className="text-center mt-4">
                  {/* <Button type="submit" color="danger">
                    Update User Name
                  </Button>{" "} */}
                  <Button
                    onClick={handlePersonalDetailsNavigate}
                    color="primary"
                  >
                    Get Personal Details ->
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UserProfile;
